import NotificationComponent from '../notification/notification'

class Notification {
  notification: NotificationComponent

  constructor(element: NotificationComponent) {
    this.notification = element
  }

  show(text: string, variant: string, duration: number = 3000): void {
    this.notification.show(text, variant, duration)
  }
}

export default Notification
